<div class="ai-extraction">
  <button
    type="button"
    mat-stroked-button
    color="primary"
    [disabled]="isDisabled"
    (click)="extractData()"
  >
    @if (isLoading) {
    <mat-spinner [diameter]="20"></mat-spinner>
    } @else {
    <mat-icon>document_scanner</mat-icon>
    }
    <span>{{ buttonText }}</span>
  </button>

  @if (errorMessage) {
  <div class="ai-extraction__error" role="alert">
    <mat-icon>warning</mat-icon>
    <span>{{ errorMessage }}</span>
  </div>
  }
</div>
